import { useEffect, useRef, useState } from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "../../../styles/navbar/CyberRoom/GlobalThreatMap.css";
import { useMamdani } from "../../../context/MamdaniContext";

// ══════════════════════════════════════════════
// קבועים
// ══════════════════════════════════════════════
const API_BASE = "https://api.anti-bot.ai";

const COUNTRY_COORDS = {
  RU: [55.75,  37.6 ],
  CN: [39.9,  116.4 ],
  IR: [35.7,   51.4 ],
  KP: [39.0,  125.7 ],
  BY: [53.9,   27.5 ],
  US: [38.9,  -77.0 ],
  DE: [52.5,   13.4 ],
  FR: [48.9,    2.3 ],
  GB: [51.5,   -0.1 ],
  TR: [39.9,   32.9 ],
  SA: [24.7,   46.7 ],
  ID: [-6.2,  106.8 ],
  IT: [41.9,   12.5 ],
  BR: [-15.8, -47.9 ],
  AU: [-35.3, 149.1 ],
  CA: [45.4,  -75.7 ],
  PK: [33.7,   73.0 ],
  IN: [28.6,   77.2 ],
  EG: [30.0,   31.2 ],
  UA: [50.4,   30.5 ],
};

const COUNTRY_INFO = {
  RU: { flag: "🇷🇺", name: "רוסיה"        },
  CN: { flag: "🇨🇳", name: "סין"          },
  IR: { flag: "🇮🇷", name: "איראן"        },
  KP: { flag: "🇰🇵", name: "צפון קוריאה" },
  BY: { flag: "🇧🇾", name: "בלארוס"      },
  US: { flag: "🇺🇸", name: "US"           },
  DE: { flag: "🇩🇪", name: "גרמניה"      },
  FR: { flag: "🇫🇷", name: "צרפת"        },
  GB: { flag: "🇬🇧", name: "בריטניה"     },
  TR: { flag: "🇹🇷", name: "טורקיה"      },
  SA: { flag: "🇸🇦", name: "ערב הסעודית" },
  ID: { flag: "🇮🇩", name: "אינדונזיה"   },
  IT: { flag: "🇮🇹", name: "איטליה"      },
  BR: { flag: "🇧🇷", name: "ברזיל"       },
  AU: { flag: "🇦🇺", name: "אוסטרליה"    },
  CA: { flag: "🇨🇦", name: "קנדה"        },
  PK: { flag: "🇵🇰", name: "פקיסטן"      },
  IN: { flag: "🇮🇳", name: "הודו"        },
  EG: { flag: "🇪🇬", name: "מצרים"       },
  UA: { flag: "🇺🇦", name: "אוקראינה"    },
};

const ISRAEL = [31.8, 35.2];

// פענוח location טקסט → קוד מדינה
function parseLocation(loc) {
  if (!loc) return null;
  const s = loc.toLowerCase();
  if (s.includes('iran') || s.includes('tehran') || s.includes('mashhad') || s.includes('isfahan')) return 'IR';
  if (s.includes('pakistan') || s.includes('islamabad') || s.includes('karachi') || s.includes('lahore')) return 'PK';
  if (s.includes('turkey') || s.includes('türkiye') || s.includes('turkiye') || s.includes('istanbul') || s.includes('ankara')) return 'TR';
  if (s.includes('russia') || s.includes('москва') || s.includes('moscow') || s.includes('saint pete')) return 'RU';
  if (s.includes('china') || s.includes('beijing') || s.includes('shanghai') || s.includes('shenzhen')) return 'CN';
  if (s.includes('north korea') || s.includes('pyongyang')) return 'KP';
  if (s.includes('united states') || s.includes('usa') || s.includes('new york') || s.includes('california') || s.includes('washington') || s.includes('texas') || s.includes('florida') || s.includes('chicago')) return 'US';
  if (s.includes('united kingdom') || s.includes(' uk') || s.includes('london') || s.includes('england') || s.includes('britain') || s.includes('manchester')) return 'GB';
  if (s.includes('germany') || s.includes('deutschland') || s.includes('berlin') || s.includes('munich') || s.includes('hamburg')) return 'DE';
  if (s.includes('france') || s.includes('paris') || s.includes('lyon') || s.includes('marseille')) return 'FR';
  if (s.includes('egypt') || s.includes('cairo') || s.includes('alexandria') || s.includes('القاهرة') || s.includes('مصر')) return 'EG';
  if (s.includes('saudi') || s.includes('riyadh') || s.includes('jeddah') || s.includes('mecca')) return 'SA';
  if (s.includes('india') || s.includes('delhi') || s.includes('mumbai') || s.includes('bangalore') || s.includes('hyderabad')) return 'IN';
  if (s.includes('indonesia') || s.includes('jakarta') || s.includes('surabaya') || s.includes('bandung')) return 'ID';
  if (s.includes('australia') || s.includes('sydney') || s.includes('melbourne') || s.includes('brisbane')) return 'AU';
  if (s.includes('canada') || s.includes('toronto') || s.includes('ottawa') || s.includes('vancouver')) return 'CA';
  if (s.includes('brazil') || s.includes('brasil') || s.includes('são paulo') || s.includes('rio de janeiro')) return 'BR';
  if (s.includes('italy') || s.includes('italia') || s.includes('rome') || s.includes('milan') || s.includes('roma')) return 'IT';
  if (s.includes('ukraine') || s.includes('kyiv') || s.includes('kiev') || s.includes('kharkiv')) return 'UA';
  if (s.includes('belarus') || s.includes('minsk')) return 'BY';
  if (s.includes('jordan') || s.includes('amman')) return 'JO';
  if (s.includes('lebanon') || s.includes('beirut')) return 'LB';
  if (s.includes('qatar') || s.includes('doha')) return 'QA';
  if (s.includes('kuwait')) return 'KW';
  if (s.includes('morocco') || s.includes('casablanca') || s.includes('rabat')) return 'MA';
  if (s.includes('algeria') || s.includes('algiers')) return 'DZ';
  if (s.includes('tunisia') || s.includes('tunis')) return 'TN';
  if (s.includes('iraq') || s.includes('baghdad') || s.includes('basra')) return 'IQ';
  if (s.includes('syria') || s.includes('damascus') || s.includes('aleppo')) return 'SY';
  if (s.includes('malaysia') || s.includes('kuala lumpur')) return 'MY';
  if (s.includes('nigeria') || s.includes('lagos') || s.includes('abuja')) return 'NG';
  if (s.includes('south africa') || s.includes('johannesburg') || s.includes('cape town')) return 'ZA';
  return null;
}

// חישוב מדינות מנתוני בוטים של ממדאני
function computeMamdaniThreats(allBots) {
  const countryMap = {};

  // ארה"ב תמיד מופיעה — ממדאני מניו יורק וכל הבוטים פועלים לטובתו
  const totalScore = allBots.reduce((s, b) => s + (b.bot_score || 0), 0);
  countryMap['US'] = {
    country_code: 'US',
    bot_count:    allBots.length,
    total_score:  totalScore,
  };

  // בנוסף — כל בוט שיש לו location מזוהה
  for (const bot of allBots) {
    const code = parseLocation(bot.location);
    if (!code || !COUNTRY_COORDS[code] || code === 'US') continue;
    if (!countryMap[code]) {
      countryMap[code] = { country_code: code, bot_count: 0, total_score: 0 };
    }
    countryMap[code].bot_count++;
    countryMap[code].total_score += bot.bot_score || 0;
  }

  return Object.values(countryMap).map(c => ({
    country_code: c.country_code,
    bot_count:    c.bot_count,
    avg_threat:   Math.round(c.total_score / Math.max(c.bot_count, 1)),
  }));
}

// הזזת label לכל מדינה [lat_offset, lng_offset] כדי למנוע חפיפה
const LABEL_OFFSETS = {
  RU: [ +7,  +8 ],   // רוסיה — למעלה ימינה
  BY: [ +7,  -2 ],   // בלארוס — למעלה
  GB: [+10, -15 ],   // בריטניה — למעלה שמאלה
  FR: [ +3,  -6 ],   // צרפת — מעט שמאלה למטה
  DE: [ +7,  +2 ],   // גרמניה — למעלה
  IT: [ -4,  +5 ],   // איטליה — למטה ימינה
  TR: [ +6,  -5 ],   // טורקיה — למעלה שמאלה
  EG: [ -6,  -6 ],   // מצרים — למטה שמאלה
  IR: [ +6,  +6 ],   // איראן — למעלה ימינה
  SA: [ -5,  +4 ],   // ערב הסעודית — למטה
  PK: [ +6,  -4 ],   // פקיסטן — למעלה שמאלה
  IN: [ -4,  +7 ],   // הודו — ימינה למטה
  CN: [ +5,  +5 ],   // סין — למעלה ימינה
  KP: [ +3, +10 ],   // צפון קוריאה — ימינה
  US: [ +7,  +2 ],   // ארה"ב — למעלה
  CA: [ +7,  -9 ],   // קנדה — למעלה שמאלה
  BR: [ -6,  -6 ],   // ברזיל — למטה שמאלה
  ID: [ -6,  +4 ],   // אינדונזיה — למטה
  AU: [ -5,  +5 ],   // אוסטרליה — למטה ימינה
  UA: [ +5,  +4 ],   // אוקראינה — למעלה
};

// ══════════════════════════════════════════════
// עזר
// ══════════════════════════════════════════════
function threatColor(score) {
  if (score >= 75) return "#ff2244";
  if (score >= 55) return "#ff8c00";
  return "#ffd700";
}

function threatLabel(level) {
  switch (level) {
    case "CRITICAL": return { text: "CRITICAL", color: "#ff2244" };
    case "HIGH":     return { text: "HIGH",     color: "#ff8c00" };
    case "MEDIUM":   return { text: "MEDIUM",   color: "#ffd700" };
    default:         return { text: "LOW",       color: "#00ff64" };
  }
}

// יצירת עקומה בין שתי נקודות
function generateCurve(from, to, points = 30) {
  const result = [];
  for (let i = 0; i <= points; i++) {
    const t   = i / points;
    const lat = from[0] + (to[0] - from[0]) * t;
    const lng = from[1] + (to[1] - from[1]) * t;
    const arc = Math.sin(Math.PI * t) * 10;
    result.push([lat + arc * 0.25, lng]);
  }
  return result;
}

// ── מזיז את המפה לפי מוד ──
function MapViewSetter({ mm }) {
  const leafletMap = useMap();
  useEffect(() => {
    if (mm) {
      leafletMap.setView([20, -20], 1.8); // זום אאוט לראות ארה"ב + ישראל
    } else {
      leafletMap.setView(ISRAEL, 2.2);
    }
  }, [mm, leafletMap]);
  return null;
}

// ══════════════════════════════════════════════
// שכבות על המפה
// ══════════════════════════════════════════════
function ThreatLayers({ threats, onCountryClick }) {
  const map       = useRef(null);
  const leafletMap = useMap();
  const layersRef = useRef([]);
  const animRef   = useRef(null);
  const linesRef  = useRef([]);

  useEffect(() => {
    // נקה layers קודמים
    layersRef.current.forEach((l) => leafletMap.removeLayer(l));
    layersRef.current = [];
    linesRef.current  = [];
    cancelAnimationFrame(animRef.current);

    if (!threats.length) return;

    // ── ישראל ──
    const israelIcon = L.divIcon({
      className: "",
      html: `
        <div class="israel-marker">
          <div class="israel-ring"></div>
          <div class="israel-ring israel-ring-2"></div>
          <div class="israel-dot"></div>
        </div>`,
      iconSize:   [70, 70],
      iconAnchor: [35, 35],
    });

    const israelMarker = L.marker(ISRAEL, { icon: israelIcon, zIndexOffset: 1000 });
    israelMarker.bindTooltip(
      `<div class="gtm-tip green-tip">🇮🇱 ISRAEL — PROTECTED</div>`,
      { permanent: true, direction: "bottom", offset: [0, 14], className: "gtm-tooltip-wrap" }
    );
    israelMarker.on('click', () => onCountryClick('ALL', { name: 'כל הבוטים', flag: '🌐' }));
    israelMarker.addTo(leafletMap);
    layersRef.current.push(israelMarker);

    // ── מדינות תוקפות ──
    threats.forEach((t) => {
      const coords = COUNTRY_COORDS[t.country_code];
      if (!coords) return;

      const col  = threatColor(t.avg_threat);
      const info = COUNTRY_INFO[t.country_code] || { flag: "🌐", name: t.country_code };

      // נקודת מקור
      const dotIcon = L.divIcon({
        className: "",
        html: `<div style="
          width:14px;height:14px;border-radius:50%;
          background:${col};
          box-shadow:0 0 12px ${col},0 0 4px ${col};
          border:1px solid rgba(255,255,255,0.3);
          transform:translate(-50%,-50%);
        "></div>`,
        iconSize:   [14, 14],
        iconAnchor: [7, 7],
      });

      // Label מעל הנקודה
      const labelIcon = L.divIcon({
        className: "",
        html: `<div style="
          display:flex;flex-direction:column;align-items:center;
          transform:translateX(-50%);
          cursor:pointer;
        ">
          <img src="https://flagcdn.com/24x18/${t.country_code.toLowerCase()}.png"
            style="width:22px;height:16px;border-radius:2px;margin-bottom:3px;
            box-shadow:0 0 4px rgba(0,0,0,0.8)"/>
          <span style="
            color:${col};font-size:11px;font-family:'Segoe UI',sans-serif;
            font-weight:bold;text-shadow:0 0 6px ${col},0 2px 4px rgba(0,0,0,0.9);
            white-space:nowrap;
          ">${info.name}</span>
          <span style="
            color:${col};font-size:9px;font-family:'Segoe UI',sans-serif;
            opacity:0.8;text-shadow:0 1px 3px rgba(0,0,0,0.9);
          ">${t.bot_count} bots</span>
        </div>`,
        iconSize:   [80, 50],
        iconAnchor: [40, 50],
      });

      const off         = LABEL_OFFSETS[t.country_code] || [3, 0];
      const labelMarker = L.marker([coords[0] + off[0], coords[1] + off[1]], { icon: labelIcon, interactive: true });

      labelMarker.on('click', () => onCountryClick(t.country_code, info));
      labelMarker.addTo(leafletMap);
      layersRef.current.push(labelMarker);

      // קשת אנימציה
      const curve = generateCurve(coords, ISRAEL, 30);
      const line  = L.polyline(curve, {
        color:     col,
        weight:    2,
        opacity:   0.85,
        dashArray: "10 6",
      });
      line.addTo(leafletMap);
      layersRef.current.push(line);

      // שמור ref ל-SVG path לאנימציה
      linesRef.current.push({ line, color: col });
    });

    // ── אנימציית dash ──
    let offset = 0;
    function animate() {
      offset -= 1.2;
      linesRef.current.forEach(({ line }) => {
        const el = line.getElement?.();
        if (el) el.style.strokeDashoffset = offset;
      });
      animRef.current = requestAnimationFrame(animate);
    }
    animRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animRef.current);
      layersRef.current.forEach((l) => leafletMap.removeLayer(l));
      layersRef.current = [];
      linesRef.current  = [];
    };
  }, [threats, leafletMap]);

  return null;
}

// ══════════════════════════════════════════════
// קומפוננטה ראשית
// ══════════════════════════════════════════════
export default function GlobalThreatMap() {
  const [threats, setThreats]      = useState([]);
  const [stats, setStats]          = useState(null);
  const [loading, setLoading]      = useState(true);
  const [panel, setPanel]          = useState(null);
  const { mamdaniMode: mm, data }  = useMamdani();

  const handleCountryClick = async (code, info) => {
    if (mm) {
      // ארה"ב = כל הבוטים (ממדאני מניו יורק); שאר מדינות = לפי location
      const bots = code === 'US'
        ? data.allBots
        : data.allBots.filter(b => parseLocation(b.location) === code);
      setPanel({ code, name: info.name, flag: info.flag, bots, loading: false });
      return;
    }
    setPanel({ code, name: info.name, flag: info.flag, bots: [], loading: true });
    try {
      const res  = await fetch(`${API_BASE}/api/cyber/bots-by-country/${code}`);
      const json = await res.json();
      setPanel(prev => ({ ...prev, bots: json.success ? json.bots : [], loading: false }));
    } catch {
      setPanel(prev => ({ ...prev, bots: [], loading: false }));
    }
  };

  // ── מוד ממדאני: חשב מדינות מהבוטים ──
  useEffect(() => {
    if (!mm) return;
    const computed = computeMamdaniThreats(data.allBots);
    setThreats(computed);
    setLoading(false);
  }, [mm, data.allBots]);

  useEffect(() => {
    if (mm) return;
    async function fetchData() {
      try {
        const [tRes, sRes] = await Promise.all([
          fetch(`${API_BASE}/api/cyber/threat-map`),
          fetch(`${API_BASE}/api/cyber/live-stats`),
        ]);
        const tJson = await tRes.json();
        const sJson = await sRes.json();

        if (tJson.success) {
          setThreats(
            tJson.threats.filter(
              (t) => t.country_code && COUNTRY_COORDS[t.country_code]
            )
          );
        }
        if (sJson.success) {
          setStats(sJson);
        }
      } catch (err) {
        console.error("GlobalThreatMap fetch error:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
    const iv = setInterval(fetchData, 60000);
    return () => clearInterval(iv);
  }, [mm]);

  const label = threatLabel(stats?.threat_level ?? "LOW");

  return (
    <div className="gtm-wrapper">

      {/* ── Header ── */}
      <div className="gtm-header">
        <div className="gtm-header-left">
          <span className="live-dot" />
          <span className="gtm-title">GLOBAL THREAT MAP</span>
        </div>
        <div className="gtm-header-right">
          <span
            className="threat-badge"
            style={{ borderColor: label.color, color: label.color }}
          >
            THREAT: {label.text}
          </span>
        </div>
      </div>

      {/* ── Map ── */}
      <div className="gtm-map">
        {loading && (
          <div className="gtm-loading">
            <span className="loading-dot" />
            <span className="loading-dot" />
            <span className="loading-dot" />
          </div>
        )}

        <MapContainer
          center={ISRAEL}
          zoom={2.2}
          zoomControl={false}
          attributionControl={false}
          style={{ width: "100%", height: "100%", background: "#060f1e" }}
        >
          <TileLayer
            url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
            subdomains="abcd"
          />
          <MapViewSetter mm={mm} />
          <ThreatLayers threats={threats} onCountryClick={handleCountryClick} />
        </MapContainer>
      </div>

      {/* ── Stats Row ── */}
      <div className="gtm-stats-row">
        <div className="gtm-stat-box">
          <span className="stat-value cyan">
            {stats?.active_bots?.toLocaleString() ?? "—"}
          </span>
          <span className="stat-label">בוטים פעילים</span>
        </div>
      </div>

      {/* ── פאנל בוטים לפי מדינה ── */}
    {panel && (
      <div style={{
        position: 'absolute', top: 0, left: 0, height: '100%', width: '320px',
        background: 'rgba(6,15,30,0.97)', borderRight: '1px solid rgba(255,255,255,0.1)',
        zIndex: 1000, display: 'flex', flexDirection: 'column', overflow: 'hidden',
        backdropFilter: 'blur(12px)'
      }}>
        <div style={{ padding: '16px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: '16px' }}>
            {panel.flag} {panel.name}
          </span>
          <button onClick={() => setPanel(null)} style={{ background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.5)', fontSize: '18px', cursor: 'pointer' }}>✕</button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '8px' }}>
          {panel.loading ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#9aa4b2' }}>
              <div className="spinner" style={{ margin: '0 auto 12px' }} />
              <p>טוען...</p>
            </div>
          ) : panel.bots.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#9aa4b2' }}>אין בוטים</div>
          ) : panel.bots.map((bot, i) => (
            <div key={i} style={{
              background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)',
              borderRadius: '10px', padding: '10px 12px', marginBottom: '8px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                <img
                  src={bot.profile_image_url || bot.profile_image || 'https://abs.twimg.com/sticky/default_profile_images/default_profile_normal.png'}
                  alt="" style={{ width: '32px', height: '32px', borderRadius: '50%', border: '1px solid rgba(255,56,56,0.5)' }}
                />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: '#fff', fontSize: '13px', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{bot.display_name || bot.name || bot.username}</div>
                  <div style={{ color: '#9aa4b2', fontSize: '11px' }}>@{bot.username}</div>
                </div>
                <span style={{
                  color: '#ff2244', fontSize: '12px', fontWeight: 700,
                  background: 'rgba(255,34,68,0.12)', border: '1px solid rgba(255,34,68,0.3)',
                  borderRadius: '6px', padding: '2px 7px'
                }}>{bot.bot_score}</span>
              </div>
              <div style={{ display: 'flex', gap: '12px', fontSize: '11px', color: '#6b7280' }}>
                {bot.followers != null && <span>👥 {bot.followers.toLocaleString()}</span>}
                {bot.created_at  && <span>📅 {bot.created_at}</span>}
                {bot.bot_type    && <span>🤖 {bot.bot_type}</span>}
                {(bot.location || bot.country_ip) && <span>🌍 {bot.location || bot.country_ip}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    )}

    </div>
  );
}